import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../../pages/App/routes";
import { useAppSelector as useSelector } from "../../../../store";

const TabsHeader = ({
  role = "super_admin",
  activeTab,
}: {
  role?: "super_admin" | "centre_admin";
  activeTab: "pending" | "approval" | "history" | "payroll-pending";
}) => {
  const navigate = useNavigate();
  const inProgress = useSelector((state) => state.timesheet.inProgress)

  const isCentreAdmin = role === "centre_admin";

  const isSuperAdmin = role === "super_admin";


  const { totalApprovalTimesheet, totalPendingTimesheet, totalPendingPayrollTimesheet } = useSelector(
    (state) => state.timesheet
  );

  let tabs = [
    {
      id: "pending",
      label: "Timesheets Pending",
      count: totalPendingTimesheet,
      route: isCentreAdmin
        ? AUTH_ROUTE.CLIENT_TIMESHEET_PENDING
        : AUTH_ROUTE.ADMIN_TIMESHEET_PENDING,
    },
    {
      id: "approval",
      label: isSuperAdmin ? "Centre Approvals Pending" : "Approvals Pending",
      count: totalApprovalTimesheet,
      route: isCentreAdmin
        ? AUTH_ROUTE.CLIENT_TIMESHEET_APPROVAL
        : AUTH_ROUTE.ADMIN_TIMESHEET_APPROVAL,
    },
    {
      id: "payroll-pending",
      label: "Payroll Pending",
      count: totalPendingPayrollTimesheet,
      route: AUTH_ROUTE.ADMIN_TIMESHEET_PAYROLL_PENDING,
    },
    {
      id: "history",
      label: isSuperAdmin ? "Sent to Payroll" : "History",
      route: isCentreAdmin
        ? AUTH_ROUTE.CLIENT_TIMESHEET_HISTORY
        : AUTH_ROUTE.ADMIN_TIMESHEET_HISTORY,
    }    
  ];

  // Reorder tabs if the type is "centre_admin"
  if (isCentreAdmin) {
    tabs = [tabs[1], tabs[0], tabs[3]];
  }

  const [isMobile, setIsMobile] = useState(window.innerWidth < 991);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth < 991);
    }

    window.addEventListener("resize", handleResize);

    // Clean up listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className={`d-flex gap-10 align-items-center  overflow-auto mobile-scroll-hide ${window.location.pathname.includes('admin/timesheet/history') ? 'payroll_completed' : ''}`}>
      {tabs.map((tab) => (
        <div
          key={tab.id}
          className={`top-radius-10px ${
            isMobile ? "py-13px" : "py-5px"
          } px-15px d-flex gap-5 align-items-center cursor-pointer 
            ${
              activeTab === tab.id
                ? "bg-black text-white"
                : "bg-off-white text-black"
            }`}
          onClick={() => navigate(tab.route)}
        >
          {!inProgress ? (
            <div className="fs-22 fs-mobile-16 fw-700">
              {typeof tab.count === "number" ? tab.count : ""}
            </div>
          ) : (
            tab.label !== "History" && (
              <div className="fs-22 fs-mobile-16 fw-700">{""}</div>
            )
          )}
          <div className="fs-22 fs-mobile-16 fw-400 tab_ellipsis">{tab.label}</div>
        </div>
      ))}
    </div>
  );
};

export default TabsHeader;
